import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  IService,
  IServiceAnalyticData,
  IServiceResponseData,
  IServiceState,
} from "../types/service";
import { IApiResponse } from "../types/api-response";

const initialState: IServiceState = {
  services: [],
  service: null,
  counts: {
    total_service: 0,
    total_active_service: 0,
    total_inactive_service: 0,
  },
  limit: 20,
  offset: 0,
  total: 0,
  loading: false,
  loadingServiceId: null,
};

export const service = createSlice({
  name: "service",
  initialState,
  reducers: {
    setServices: (
      state,
      action: PayloadAction<IApiResponse<IServiceResponseData>>,
    ) => {
      state.services = action.payload.data.data;
      state.limit = action.payload.data.limit;
      state.offset = action.payload.data.offset;
      state.total = action.payload.data.total;
    },
    setService: (state, action: PayloadAction<IService>) => {
      state.service = action.payload;
    },
    createService: (state, action: PayloadAction<IService>) => {
      state.services = [action.payload, ...state.services];
      state.total += 1;
      state.offset = 0;
    },
    editService: (state, action: PayloadAction<IService>) => {
      state.services = state.services.map((item) => {
        if (item.id === action.payload.id) return action.payload;
        return item;
      });
      if (state.service?.id === action.payload.id) {
        state.service = action.payload;
      }
    },
    setSearch: (state, action) => {
      state.services = action.payload.data;
    },
    deleteService: (state, action: PayloadAction<number>) => {
      state.services = state.services.filter(
        (item) => item.id !== action.payload,
      );
      state.total = Math.max(0, state.total - 1);
      if (state.service?.id === action.payload) {
        state.service = null;
      }
      if (state.offset >= state.total && state.offset > 0) {
        state.offset = Math.max(0, state.offset - state.limit);
      }
    },
    setTotal: (state, action: PayloadAction<IServiceAnalyticData>) => {
      state.counts = action.payload;
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    setOffset: (state, action: PayloadAction<number>) => {
      state.offset = action.payload;
    },

    setLoadingServiceId: (state, action: PayloadAction<number | null>) => {
      state.loadingServiceId = action.payload;
    },

    disableLoading: (state) => {
      state.loading = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setSearch,
  setLoading,
  setOffset,
  setLoadingServiceId,
  disableLoading,
  deleteService,
  setTotal,
  setServices,
  setService,
  createService,
  editService,
} = service.actions;

export default service.reducer;
